import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebase';

export default function AffiliateClaimView() {
  const [form, setForm] = useState({ purchaseEmail: '', refCode: '', description: '' });
  const [state, setState] = useState('idle'); // idle | loading | success | error
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.purchaseEmail.trim() || !form.refCode.trim()) {
      setError('Email pembelian dan kod rujukan wajib diisi.');
      return;
    }

    setState('loading');
    try {
      await addDoc(collection(db, 'affiliate_manual_claims'), {
        purchaseEmail: form.purchaseEmail.trim().toLowerCase(),
        refCode: form.refCode.trim().toUpperCase(),
        description: form.description.trim(),
        claimantUid: auth.currentUser?.uid || null,
        claimantEmail: auth.currentUser?.email || null,
        status: 'pending',
        createdAt: serverTimestamp()
      });
      setState('success');
    } catch (err) {
      console.error('[AffiliateClaim] Submit error:', err);
      setError('Gagal menghantar. Sila cuba lagi.');
      setState('error');
    }
  };

  if (state === 'success') {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center max-w-sm">
          <div className="w-16 h-16 rounded-2xl bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center mx-auto mb-4">
            <span className="material-symbols-outlined text-emerald-500 text-3xl">mark_email_read</span>
          </div>
          <h2 className="text-xl font-bold text-slate-800 dark:text-white mb-2">Tuntutan Dihantar!</h2>
          <p className="text-slate-500 dark:text-slate-400 text-sm">
            Pasukan kami akan semak dan proses tuntutan anda dalam masa 3–5 hari bekerja.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 flex items-center justify-center p-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-slate-800 dark:text-white mb-2">Tuntut Komisen Hilang</h1>
          <p className="text-slate-500 dark:text-slate-400 text-sm">
            Jika pembelian berlaku tapi komisen tidak dicatat, isi borang ini untuk semakan manual.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
              Email Digunakan Semasa Beli <span className="text-red-400">*</span>
            </label>
            <input
              type="email"
              required
              value={form.purchaseEmail}
              onChange={e => setForm(f => ({ ...f, purchaseEmail: e.target.value }))}
              placeholder="email@contoh.com"
              className="w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 rounded-xl text-slate-800 dark:text-slate-200 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
              Kod Rujukan Affiliate <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              required
              value={form.refCode}
              onChange={e => setForm(f => ({ ...f, refCode: e.target.value }))}
              placeholder="Cth: AFR-A1B2"
              className="w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 rounded-xl text-slate-800 dark:text-slate-200 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm font-mono"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
              Maklumat Tambahan (pilihan)
            </label>
            <textarea
              rows={3}
              value={form.description}
              onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
              placeholder="Cth: Beli pada 15 April 2026, guna link dari TikTok @xxx"
              className="w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 rounded-xl text-slate-800 dark:text-slate-200 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm resize-none"
            />
          </div>

          {(error || state === 'error') && (
            <p className="text-sm text-red-400">{error || 'Ralat. Sila cuba lagi.'}</p>
          )}

          <button
            type="submit"
            disabled={state === 'loading'}
            className="w-full py-3 bg-emerald-500 hover:bg-emerald-600 disabled:opacity-50 text-white rounded-xl font-semibold transition-colors"
          >
            {state === 'loading' ? 'Menghantar...' : 'Hantar Tuntutan'}
          </button>
        </form>
      </div>
    </div>
  );
}
